import Fakerator from "fakerator";
import dayjs from "dayjs";
import _ from "lodash";

import request from "@form/utils/request";
import type { Token } from "@form/types";

const fake = Fakerator();
fake.seed(5567832 as any);

declare type SocialAccount = {
  handle: string;
};

export interface FormResponse {
  name?: string;
  email?: string;
  is_email_verified: false;
  create_time: string;
  update_time: string;
  status: string;
  twitter?: {
    id: string;
    name: string;
    username: string;
  };
  user_id: number;
  holder: boolean;
  user_address: string;
  context: {
    question?: string;
    source?: string;
  };
  campagin_id: string;
  address: string;
  tags?: { name: string; icon: string }[];
  eth: string;
  bluechip: {
    holdings: {
      address: string;
      balance: number;
      token: Token;
    }[];
  };
  ens: string;
  ext: null;
  wallet_create_time: string;
  last_activity_time: string;
  social_info?: {
    twitter?: {
      id: string;
      name: string;
      username: string;
    };
    discord?: {
      username: string;
      id: string;
      global_name?: string;
    };
    email?: {
      email: string;
    };
  };
  tokenBalance?: number;
}

export interface DataType {
  address: string;
  twitter?: SocialAccount;
  email?: SocialAccount;
  eth: number;
  holder: boolean;
  bluechip: {
    address: string;
    balance: number;
    token: Token;
  }[];
  wallet_create_time: string | null;
  last_activity_time: string | null;
  tags: { name: string; icon: string }[];
  isPreview?: boolean;
  ens?: string;
  answer?: string;
  social_info?: FormResponse["social_info"];
  tokenBalance?: number;
  source?: string;
  tokenAmount?: string;
  karatScore?: number;
}

export function responseToTableData(response: FormResponse): DataType {
  const res = {} as DataType;
  res.address = response.user_address;
  if (response.twitter) {
    res.twitter = {
      handle: response.twitter.username,
    };
  }
  if (response.email) {
    res.email = {
      handle: response.email,
    };
  }
  res.ens = response.ens;
  res.holder = response.holder;
  res.eth = response.eth ? parseFloat(response.eth) : 0;
  res.bluechip = response?.bluechip?.holdings || [];
  res.wallet_create_time = response.wallet_create_time;
  res.last_activity_time = response.last_activity_time;
  res.tags = response.tags || [];
  res.answer = response?.context?.question;
  res.source = response?.context?.source;
  res.social_info = response.social_info;
  res.tokenBalance = response.tokenBalance;
  return res;
}

export const tableData: DataType[] = [];

export const previewData: DataType[] = [
  {
    isPreview: true,
    address: "0x8e22B546B8684B1217308D03af8D51263d15E7C9",
    eth: fake.random.number(1, 200),
    holder: fake.random.boolean(),
    bluechip: [
      {
        address: "0x0000000C01915E253A7f1017C975812eDd5E8ECC",
        token: {
          _id: "1-0xed5af388653567af2f388e6224dc7c4b3241c544",
          name: "Azuki",
          symbol: "AZUKI",
          logoURI:
            "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s120",
          address: "0xed5af388653567af2f388e6224dc7c4b3241c544",
          type: "ERC721",
          initBlock: 13975839,
          source: "primary",
        },
        balance: 1,
      },
      {
        address: "0x0000000C01915E253A7f1017C975812eDd5E8ECC",
        token: {
          _id: "1-0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b",
          name: "CLONE X - X TAKASHI MURAKAMI",
          symbol: "CloneX",
          logoURI:
            "https://lh3.googleusercontent.com/XN0XuD8Uh3jyRWNtPTFeXJg_ht8m5ofDx6aHklOiy4amhFuWUa0JaR6It49AH8tlnYS386Q0TW_-Lmedn0UET_ko1a3CbJGeu5iHMg=s120",
          address: "0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b",
          chainId: "1",
          type: "ERC721",
          initBlock: 13790684,
          source: "primary",
        },
        balance: 1,
      },
    ] as any,
    wallet_create_time:
      "" +
      dayjs(
        fake.date.between(
          dayjs().subtract(1, "year").toDate(),
          dayjs().toDate()
        )
      ).unix(),
    last_activity_time:
      "" +
      dayjs(
        fake.date.between(
          dayjs().subtract(1, "year").toDate(),
          dayjs().toDate()
        )
      ).unix(),
    tags: [],
  },
];

for (let i = 0; i < 50; i++) {
  tableData.push({
    karatScore: fake.random.number(0, 100),
    address: "0x8e22B546B8684B1217308D03af8D51263d15E7C9",
    twitter: fake.random.boolean() ? { handle: "0xCharlesh" } : undefined,
    email: fake.random.boolean()
      ? { handle: fake.internet.email() }
      : undefined,
    eth: fake.random.number(1, 200),
    holder: fake.random.boolean(),
    bluechip: [
      {
        address: "0x0000000C01915E253A7f1017C975812eDd5E8ECC",
        token: {
          _id: "1-0xed5af388653567af2f388e6224dc7c4b3241c544",
          name: "Azuki",
          symbol: "AZUKI",
          logoURI:
            "https://lh3.googleusercontent.com/H8jOCJuQokNqGBpkBN5wk1oZwO7LM8bNnrHCaekV2nKjnCqw6UB5oaH8XyNeBDj6bA_n1mjejzhFQUP3O1NfjFLHr3FOaeHcTOOT=s120",
          address: "0xed5af388653567af2f388e6224dc7c4b3241c544",
          type: "ERC721",
          initBlock: 13975839,
          source: "primary",
        },
        balance: 1,
      },
      {
        address: "0x0000000C01915E253A7f1017C975812eDd5E8ECC",
        token: {
          _id: "1-0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b",
          name: "CLONE X - X TAKASHI MURAKAMI",
          symbol: "CloneX",
          logoURI:
            "https://lh3.googleusercontent.com/XN0XuD8Uh3jyRWNtPTFeXJg_ht8m5ofDx6aHklOiy4amhFuWUa0JaR6It49AH8tlnYS386Q0TW_-Lmedn0UET_ko1a3CbJGeu5iHMg=s120",
          address: "0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b",
          chainId: "1",
          type: "ERC721",
          initBlock: 13790684,
          source: "primary",
        },
        balance: 1,
      },
    ] as any,
    wallet_create_time:
      "" +
      dayjs(
        fake.date.between(
          dayjs().subtract(1, "year").toDate(),
          dayjs().toDate()
        )
      ).unix(),
    last_activity_time:
      "" +
      dayjs(
        fake.date.between(
          dayjs().subtract(1, "year").toDate(),
          dayjs().toDate()
        )
      ).unix(),
    tags: [],
  });
}

export const getResponse = async (
  campaignId: string
): Promise<FormResponse[]> => {
  return await request.rpc("campaign_response/get_campaign_response", {
    campaign_id: campaignId,
  });
};

export function socialAccounts(item: DataType) {
  const accounts = [] as any[];
  if (item?.social_info?.email) {
    accounts.push(item.social_info.email);
  }
  if (item?.social_info?.twitter) {
    accounts.push(item.social_info.twitter);
  }
  if (item?.social_info?.discord) {
    accounts.push(item.social_info.discord);
  }
  return accounts;
}

export function toCSVJSON(items: DataType[]) {
  const data = _.cloneDeep(items);
  return data.map((item: any) => {
    if (item.email) {
      item.email = item.email.handle;
    }
    if (item.bluechip) {
      item.bluechip = item.bluechip.map((item: any) => {
        return item.token.name;
      });
    }
    item.wallet_create_time = item.wallet_create_time
      ? dayjs.unix(parseInt(item.wallet_create_time)).toLocaleString()
      : "";
    item.last_activity_time = item.last_activity_time
      ? dayjs.unix(parseInt(item.last_activity_time)).toLocaleString()
      : "";
    if (item?.social_info?.twitter) {
      item.twitter = item.social_info.twitter.username;
    }
    if (item?.social_info?.discord) {
      item.discord =
        item.social_info.discord.global_name ||
        item.social_info.discord.username;
    }
    if (item?.social_info?.email) {
      item.email = item.social_info.email.email;
    }
    delete item.social_info;
    return item;
  });
}

export declare type ResponseSummary =
  | {
      id: "balance";
      minBalance: number;
      amount: number;
    }
  | {
      id: "social";
      amount: number;
    }
  | {
      id: "recurring";
      amount: number;
    }
  | {
      id: "holder";
      amount: number;
    }
  | {
      id: "has_similar_asset";
      amount: number;
    };

export const getSummary = async (
  campaignId: string
): Promise<ResponseSummary[]> => {
  if (campaignId === "new") {
    return [
      {
        id: "balance",
        minBalance: 1,
        amount: 0,
      },
      {
        id: "social",
        amount: 0,
      },
      {
        id: "recurring",
        amount: 0,
      },
      {
        id: "holder",
        amount: 0,
      },
      {
        id: "has_similar_asset",
        amount: 0,
      },
    ];
  }
  return await request.rpc("campaign_response/get_summary", {
    campaign_id: campaignId,
  });
};

export const getLength = async (campaignId: string): Promise<number> => {
  return await request.rpc("campaign_response/get_length", {
    campaign_id: campaignId,
  });
};

export const getResponseStatus = async (
  campaignId: string
): Promise<{
  email?: string;
  answer?: string;
  id: number;
  context: {
    question?: string;
  };
} | null> => {
  return await request.rpc("campaign_response/get_response_status", {
    campaign_id: campaignId,
  });
};

export const getSummaryWallets = async (
  campaignId: string,
  summary: string
): Promise<string[]> => {
  return await request.rpc("campaign_response/get_summary_wallets", {
    campaign_id: campaignId,
    summary,
  });
};
